import moment from "moment-timezone";

export default (date=undefined, tz='europe/helsinki') =>
    moment(date).tz(tz).format("YYYY-MM-DD HH:mm:ss")
